import { styles } from "./styles";
import heart from "../../static/heart.svg";
import money from "../../static/money.svg";

const GameStats = () => {
  return (
    <>
      {/* Game Stats */}
      <div id="gameStats" style={styles.gameStats}>
        <div style={styles.innerDiv}>
          {/* <!-- Hearts Count --> */}
          <img src={heart} alt="Heart Icon" width="35" height="35" />
          <span id="hearts-count">10</span>
        </div>
        <div style={styles.innerDiv}>
          {/* <!-- Money Count --> */}
          <img src={money} alt="Money Icon" width="35" height="35" />
          <span id="money-count">500</span>
        </div>
      </div>
    </>
  );
};

export default GameStats;
